import React from 'react'
import { Link2, Link2Off } from 'lucide-react'
import { cn } from '@/utils/index'

type GutterLinkButtonProps = {
  linked: boolean
  onToggle: () => void
}

/** Chain toggle between the column and row gutter inputs. */
export const GutterLinkButton: React.FC<GutterLinkButtonProps> = ({ linked, onToggle }) => {
  return (
    <button
      type="button"
      aria-label={linked ? 'Unlink gutters' : 'Link gutters'}
      aria-pressed={linked}
      className={cn(
        'flex h-8 self-center items-center justify-center gap-2 rounded-md bg-transparent px-[6px] py-[10px] text-[var(--base-foreground,#0A0A0A)]',
        'transition-colors hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring,#144087)]/30'
      )}
      onClick={onToggle}
    >
      {linked ? <Link2 className="h-4 w-4" /> : <Link2Off className="h-4 w-4" />}
    </button>
  )
}
